import { App as VueApp, createApp, h } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import { Logger } from '@/services/logger';
import configuration from '@/configuration';

const elementName = configuration.customElement as string;

class HobiConsentManagement extends HTMLElement {
  private app: VueApp | null = null;
  private mountPoint: HTMLElement | null = null;

  connectedCallback() {
    this.mountPoint = document.querySelector(elementName);
    this.setup();
  }

  setup() {
    if (this.app) this.app.unmount();

    if (this.mountPoint) {
      this.app = createApp({
        render: () => h(App),
      });

      this.app.use(createPinia());

      this.app.mount(this.mountPoint);
      Logger.logInfo(`${elementName}: Mount point found`);
    } else {
      Logger.logInfo(`${elementName}: Mount point not found`);
    }
  }
}

if (!window.customElements.get(elementName)) {
  const existingElement = document.querySelector<HTMLElement>(elementName);

  if (!existingElement) {
    const element = document.createElement(elementName);
    document.body.appendChild(element);
  }

  window.customElements.define(elementName, HobiConsentManagement);
} else {
  Logger.logWarning(`${elementName}: Custom element already defined`);
}
